import React from 'react'
import Space from 'containers/Space'

export default ({ children }) => (
  <div style={{ color: '#3bc569' }}>
    {children}
    <Space />
  </div>
)
